module.exports = __webpack_public_path__ + "static/media/logo11.84ff1f96.png";